import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { QuickSelectionModel, SelectionEventModel, TreeItemNode } from '@shared/models/tree-selector.models';
import { EntitySetting } from '../../../models/entity-setting.model';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
    standalone: false,
    selector: 'lib-app-transaction-settings',
  templateUrl: './transaction-settings.component.html',
  styleUrls: ['./transaction-settings.component.scss']
})
export class TransactionSettingsComponent implements OnInit, OnDestroy {
  @Input('sourceA') sourceA$: BehaviorSubject<EntitySetting[]> = new BehaviorSubject([]);
  @Input('sourceB') sourceB$: BehaviorSubject<EntitySetting[]> = new BehaviorSubject([]);
  @Input('streamData') streamData$: BehaviorSubject<TreeItemNode[]> = new BehaviorSubject([]);
  @Input('resetSelection') resetSelection$: Subject<any> = new Subject<any>();
  @Input('selectedSources') selectedSources$: Subject<any> = new Subject<any>();
  @Input('streamQuickSelectionsOptions') streamQuickSelectionsOptions$: Observable<QuickSelectionModel[]>;
  @Input() itemViewerName: string;
  @Output() countryClicked: EventEmitter<{settings: EntitySetting, isPaying: boolean}> = new EventEmitter();
  @Output() streamSelected: EventEmitter<SelectionEventModel> = new EventEmitter();
  @Output() streamQuickSelectionClicked: EventEmitter<QuickSelectionModel> = new EventEmitter();
  unSubscribe$ = new Subject<void>();
  showReceiving = false;
  showStream = false;
  sourceASelectedItemId$: Subject<any> = new Subject<any>();
  sourceBSelectedItemId$: Subject<any> = new Subject<any>();

  constructor() {}

  ngOnInit() {
    this.subscribeToObservables();
  }

  private subscribeToObservables () {
    this.resetSelection$.pipe(
      takeUntil(this.unSubscribe$)).subscribe((data: any) => {
      if (data.resetPaying) {
        this.showReceiving = false;
      } else if (data.resetReceiving) {
        this.showStream = false;
      }

      if ( data.resetPaying && data.resetReceiving) {
        this.showReceiving = false;
        this.showStream = false;
      }
    });
    this.selectedSources$.pipe(
      takeUntil(this.unSubscribe$)).subscribe((data: any) => {
      if (data.sourceASelectedItem) {
        this.sourceASelectedItemId$.next({id: data.sourceASelectedItem});
      }
      if (data.sourceBSelectedItem) {
        this.sourceBSelectedItemId$.next({id: data.sourceBSelectedItem});
      }
      this.showReceiving = true;
      this.showStream = true;
    });
  }

  ngOnDestroy (): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onCountryClick(event: {settings: EntitySetting, isPaying: boolean}) {
    if (event.isPaying) {
      this.showReceiving = true;
    } else {
      this.showStream = true;
    }
    this.countryClicked.emit(event);
  }

  onStreamSelectionChanged(event: SelectionEventModel) {
    //console.log('onStreamSelectionChanged selection changed', event);
    this.streamSelected.emit(event);
  }

  onStreamQuickSelectionClick(event: QuickSelectionModel) {
    this.streamQuickSelectionClicked.emit(event);
  }

}
